import script from "./header.vue?vue&type=script&setup=true&lang=js"
export * from "./header.vue?vue&type=script&setup=true&lang=js"

import "./header.vue?vue&type=style&index=0&id=7160739b&lang=css"
import "./header.vue?vue&type=style&index=1&id=7160739b&lang=scss&scoped=true"
import "./header.vue?vue&type=style&index=2&id=7160739b&lang=scss"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-7160739b"]])

export default __exports__